
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Risk_grading_after_resection_of_gastrointestinal_stromal_tumors',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Risk_grading_after_resection_of_gastrointestinal_stromal_tumors.vue